<template>
	<div class="map" id="signMap" style="width: 100%;height: 100%;"></div>
</template>

<script>
	import changsanjiaoMapJson from "@/common/deltaMap";
	export default {
		mounted() {
			
		},
		methods: {
			// 获取地图数据
			getData(data){
				this.mapChart(data);
			},
			mapChart(list) {
				let mapChart = this.$echarts.init(document.getElementById('signMap'));
				this.$echarts.registerMap('changsanjiao', changsanjiaoMapJson);
				for(var i in list){
					list[i].name = list[i].city
					if(list[i].id == 1){
						list[i].value = [118.767413, 32.041544, 444]
					}else if(list[i].id == 2){
						list[i].value =[120.153576, 30.287459, 444]
					}else if(list[i].id == 3){
						list[i].value =[121.472644, 31.231706, 444]
					}else if(list[i].id == 4){
						list[i].value =[117.283042, 31.86119, 444]
					}
				}
				var option = {
					tooltip:{
						show:false,
					},
					series: [{
						type: 'map',
						map: "changsanjiao", //上面引入的数据名
						mapType: 'china',
						zoom:1.28,
						data:list,
						label: {
							normal: {
								show: true,
								color: '#fff',
								fontSize:16,
								lineHeight:26,
								fontWeight:'normal',
								formatter: function (params) {
									return params.name +"\n"+ '万人有效：' + params.data.yxfmwr.toFixed(1)
									+"\n"+ '发明授权：' + params.data.sqfmzl + '件' 
									+"\n"+ '发明有效：' + params.data.yxfmzl + '件';
								},
								
							},
						},
						itemStyle: {
							normal: {
								borderWidth:1,
								borderColor: "#07E2F4", //地图区域的边框
								areaColor: "#2498CF",
							},
							emphasis: { 
								label: {
									color: "#fff",
									show: true ,
								},
								areaColor: "#4F7FFF",
							}
						},
					}]
				}
				mapChart.setOption(option);
				window.addEventListener("resize", function() {
					mapChart.resize();
				});
			},
		},
	};
</script>

<style>
</style>